import { useQuery } from '@tanstack/react-query';
import { requestVideoKeys } from '../api/keys';
import { fetchTrips } from '../api/requestVideoApi';
import { STALE_TIME } from '../utils/constants';
import { dayBounds } from '../utils/timeZone';
import { normalizeTrips } from '../utils/unit';

const NO_TRIPS = [];

export const useTripsOfDay = ({ activityUnitId, dayKey, timeZone }) => {
  const enabled = Boolean(activityUnitId && dayKey);
  const query = useQuery({
    queryKey: requestVideoKeys.trips(activityUnitId, dayKey, timeZone),
    queryFn: () => fetchTrips({ activityUnitId, ...dayBounds(dayKey, timeZone) }),
    select: normalizeTrips,
    staleTime: STALE_TIME.trips,
    enabled,
  });

  return {
    trips: query.data || NO_TRIPS,
    isLoading: enabled && query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  };
};
